'use client';

import { useQuery } from '@tanstack/react-query';
import clsx from 'clsx';

import { LogClick, Section, Spacing } from '~/components';

import { homeLayoutQueryOptions } from '~/app/(home)/_queries';

import { useEnvironmentInfo } from '~/hooks';
import { goToFullWebviewOnApp } from '~/services/app-interface';
import { BUTTON_ID, EVENT_ACTION, EVENT_TYPE, PAGE_ID } from '~/apis/log/constant';
import { HomeShortCutItem } from '../HomeShortCutItem/HomeShortCutItem';
import munuShortcutIcon from '~/public/assets/icons/ic_menu_shortcut.webp';

import globalStyles from '~/styles/utils.module.css';
import styles from './HomeShortCut.module.css';

export const HomeShortCut = () => {
  const { data } = useQuery(homeLayoutQueryOptions);
  const { isWebview } = useEnvironmentInfo();

  const handleShortCutClick = (url: string) => {
    if (isWebview) {
      goToFullWebviewOnApp({ url }).go();
      return;
    }
    globalThis.window.open(url, '_blank');
  };

  const categoryPageDomain = globalThis?.window?.location.origin ?? process.env.NEXT_PUBLIC_DOMAIN;
  const categoryPageUrl = `${categoryPageDomain}/category`;

  return (
    <>
      <Section fullWidth>
        <div className={clsx(styles.container, globalStyles.scrollXHidden)}>
          <HomeShortCutItem
            label="카테고리"
            imageUrl={munuShortcutIcon}
            webUrl={categoryPageUrl}
            onClick={() => handleShortCutClick(categoryPageUrl)}
          />
          {data?.shortcuts?.slice(0, 10).map((shortcut, idx) => (
            <LogClick
              key={idx}
              params={{
                event_type: EVENT_TYPE.SELECT,
                event_action: EVENT_ACTION.SELECT_BUTTON,
                page_id: PAGE_ID.HOME,
                button_id: BUTTON_ID.SHORT_CUT,
                button_label: shortcut.label,
                button_label2: String(idx + 1),
              }}
            >
              <HomeShortCutItem
                label={shortcut.label}
                imageUrl={shortcut.imageUrl}
                webUrl={shortcut.webUrl}
                onClick={() => handleShortCutClick(shortcut.webUrl)}
              />
            </LogClick>
          ))}
        </div>
      </Section>
      <Spacing height={20} />
    </>
  );
};
